import defaultCustomerLogo from "../../../assets/odp.png";

import bobsLogo from "../../../assets/bobs.png";
import bbyLogo from "../../../assets/bby.png";
import boaLogo from "../../../assets/boa.png";

export default function getCustomerBrandByKey(customerKey) {
  const key = (customerKey || "").toLowerCase();

  const brands = {
    bobs: { name: "Bobs Discount Furniture", logoSrc: bobsLogo, alt: "Bobs", product_alias: "Bobs Cloud" },
    bby: { name: "Best Buy", logoSrc: bbyLogo, alt: "BBY" , product_alias: "Merch Cloud"},
    boa: { name: "Bank Of America", logoSrc: boaLogo, alt: "BoA" , product_alias: "Merch Cloud"},
    tmobile: { name: "T-Mobile", logoSrc: defaultCustomerLogo, alt: "TMO", product_alias: "Merch Cloud" },
    atts: { name: "AT&T", logoSrc: defaultCustomerLogo, alt: "AT&T", product_alias: "AT&T Cloud" },
  };

  return brands[key] || { name: "One Door Platform", logoSrc: defaultCustomerLogo, alt: "ODP", product_alias: "ODP Cloud" };
}
